module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-GB"
    }
  }, [_vm._v("S"), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("ilver Hopes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The smell of the rain and the woods flowed through the wind and")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Carried wisps of his hair with them.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The afternoon light filtered through the clouds")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Beaming down at him.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("At the end of his path he was met with a river.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("At first glance nothing seemed out of the ordinary;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("It had a bank, stones and")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Yellow dandelions which were scattered around it.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("However the river itself was different.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Its waters slid over each other in silver sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Each movement flowed serenely, unaware of their beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("No one ripple was the same as")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("It reflected the sunlight, hiding its secrets")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Beneath shades of silver and white.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Mesmerised he stood there with a longing")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("For the knowledge that the river knows.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("He wanted to run his hands through its waters and share his secrets.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Did other people see the river as he did?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Or do they walk across the concrete bridge")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Unknowing and unaware of the marvels around them?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5b56306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035801855_EPUB-6.vue
// module id = 75
// module chunks = 0